import { useSyncExternalStore, useMemo } from "react";
import { CreditCardService } from "@domain/services/creditCard.service";

export function useCreditCard() {
  const store = CreditCardService.getStore();
  const state = useSyncExternalStore(store.subscribe, store.getState);

  const functions = useMemo(
    () => ({
      fetchCards: CreditCardService.fetchCards.bind(CreditCardService),
      addCard: CreditCardService.addCard.bind(CreditCardService),
      setCardDefault: CreditCardService.setCardDefault.bind(CreditCardService)
    }),
    []
  );

  return {
    savedCards: state.savedCards,
    ...functions
  };
}
